import styled from 'styled-components';

export const LanguageSelectorContainer = styled.div`
  position: fixed;
  top: 15px;
  left: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1050;
  
  @media (max-width: 768px) {
    top: 10px;
    left: 10px;
  }
`;

// Switch container
export const LanguageSwitch = styled.div`
  width: 72px;
  height: 34px;
  background-color: rgba(40, 40, 40, 0.15);
  border-radius: 34px;
  padding: 2px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  overflow: hidden;
  
  background: linear-gradient(
    to right,
    rgba(30, 30, 30, 0.16) 0%,
    rgba(50, 50, 50, 0.28) 50%,
    rgba(30, 30, 30, 0.11) 100%
  );
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    filter: brightness(1.2);
  }
`;

// Switch slider with flag
export const SwitchSlider = styled.div<{ $isEN: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: ${props => props.$isEN ? 'calc(100% - 32px)' : '2px'};
  transition: left 0.3s ease, transform 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 5;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 0;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.6);
  
  &:hover {
    transform: scale(1.1);
  }
`;

// FlagImage container
export const FlagImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  padding: 0;
  margin: 0;
`;

// Language Label
export const LanguageLabel = styled.span<{ $isActive: boolean }>`
  font-size: 12px;
  font-weight: bold;
  color: ${props => props.$isActive ? 'transparent' : 'rgba(255, 255, 255, 0.8)'};
  z-index: 10;
  transition: color 0.3s ease;
  margin: 0 6px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  
  opacity: ${props => props.$isActive ? 0 : 1};
  visibility: ${props => props.$isActive ? 'hidden' : 'visible'};
`; 